<div class="spinner" [class.text-spinner]="showText" [class.horizontal]="horizontal">
  <div class="spinner__container" [class.auto]="autoSize" [class.crescent]="crescent">
    <svg viewBox="24 24 48 48">
      <circle transform="translate(0,0)" cx="48" cy="48" r="20"></circle>
    </svg>
  </div>
  <span class="spinner__text" *ngIf="showText">{{ 'HIGHLIGHTER.LOADING' | translate }}</span>
</div>
